var t=function(t){return(null==t?void 0:t.startsWith("http://"))||(null==t?void 0:t.startsWith("https://"))||(null==t?void 0:t.startsWith("//"))};export{t as isExternalLink};
//# sourceMappingURL=is-external-link.js.map
